import React from "react";
import { Link } from "react-router-dom";
import {
  academyPath,
} from "../routes/path";
import {
  FaFacebook,
  FaInstagram,
  FaSquareWhatsapp,
  FaTelegram,
} from "react-icons/fa6";

const faqs = [
  {
    id: 1,
    show: false,
    outerText: "What is Maqraha Ul Tanzeel?",
    innerText: () => (
      <p className="">
        Maqraha ul Tanzeel is an online Quran institute specializing in teaching
        Quran memorization (Hifz), Tajweed, and the ten Qira’at (Qira’aat
        Ashara). We provide structured and personalized Quranic education for
        students of all age worldwide.
      </p>
    ),
  },
  {
    id: 2,
    show: false,
    outerText: "Who can enroll in Maqraha Ul Tanzeel?",
    innerText: () => (
      <ul className="list-disc ms-2">
        <li>
          Children, teenagers, and adults from beginner to advanced levels.
        </li>
        <li>
          Anyone [Inter]ested in learning Quran recitation, Tajweed, or advanced
          Qira’at.
        </li>
        <li>
          Those seeking Ijazah (certification) in Quranic recitation from
          qualified scholars.
        </li>
      </ul>
    ),
  },
  {
    id: 3,
    show: false,
    outerText: "Do I need prior knowledge of the Quran to join?",
    innerText: () => (
      <p>
        No, Maqraha Ul Tanzeel welcomes students at all levels, from beginners
        to advanced learners.
      </p>
    ),
  },
  {
    id: 4,
    show: false,
    outerText: "What courses do you offer?",
    innerText: () => (
      <ul className="list-disc ms-2">
        We offer a variety of courses, including:
        <li>Basic Quran Reading (for beginners)</li>
        <li>Tajweed (Proper Pronunciation)</li>
        <li>Quran Memorization (Hifz Program)</li>
        <li>Qira’at (10 Recitations & 20 Riwayat)</li>
        <li>Islamic Studies & Tafsir</li>
      </ul>
    ),
  },
  {
    id: 5,
    show: false,
    outerText: "How are the classes conducted?",
    innerText: () => (
      <ul className="list-disc ms-2">
        <li>
          All classes are conducted online via Zoom, Google Meet, or other
          virtual platforms(Whats'App).
        </li>
        <li>One-on-one private lessons and group classes are available.</li>
        <li>
          [Inter]active learning with screen sharing, digital whiteboards, and
          live recitation.
        </li>
      </ul>
    ),
  },
  {
    id: 6,
    show: false,
    outerText: "What is the duration of each courses?",
    innerText: () => (
      <ul className="list-disc ms-2">
        <li>
          The duration varies depending on the course and the student’s learning
          speed.
        </li>
        <li>
          Hifz programs may take between 6 months to 5 years depending on
          memorization capacity.
        </li>
        <li>
          Qira’at & Ijazah programs depend on the student’s prior knowledge and
          dedication.
        </li>
      </ul>
    ),
  },
  {
    id: 7,
    show: false,
    outerText: "Are the tutors qualified and who are they?",
    innerText: () => (
      <ul className="list-disc ms-2">
        <li>
          {" "}
          Yes, all tutors are certified scholars and Quran instructors with
          expertise in Tajweed, Hifz, multiple Qira’at and Islamic education.
        </li>
        <li>
          Our Lead Instructor: Qari & Muqri Abu Malik Abdul Qudus is a
          recognized scholar who has trained students in Nigeria, Sudan, and
          other countries.
        </li>
      </ul>
    ),
  },
  {
    id: 8,
    show: false,
    outerText: "What language are the classes taught in?",
    innerText: () => (
      <p className="mb-3">
        Classes are conducted primarily in English and Arabic, with possible
        support for other languages.
      </p>
    ),
  },
  {
    id: 9,
    show: false,
    outerText: "Can I choose my own class schedule?",
    innerText: () => (
      <p>
        Yes! We offer flexible scheduling to accommodate different time zones.
        Students can pick convenient class times.
      </p>
    ),
  },
  {
    id: 10,
    show: false,
    outerText: "How do I register?",
    innerText: () => (
      <p>
        [Inter]ested students can register through this our official website or
        by contacting the administration +234 815 378 3287.
      </p>
    ),
  },
  {
    id: 11,
    show: false,
    outerText: "Do we have a student community?",
    innerText: () => (
      <p>
        Yes! Students can join our online community for discussions, motivation,
        and Quranic resources.
      </p>
    ),
  },
  {
    id: 12,
    show: false,
    outerText: "What happens after I complete my course?",
    innerText: () => (
      <ul className="list-disc">
        <li>Students receive a completion certificate.</li>
        <li>
          Advanced students can apply for Ijazah or Qira’at specialization.
        </li>
        <li>
          Continued mentorship is available for those who wish to become
          instructors.
        </li>
      </ul>
    ),
  },
  {
    id: 13,
    show: false,
    outerText: "Can parents monitor their child’s progress?",
    innerText: () => (
      <p>
        Yes, parents receive regular progress reports and can communicate with
        tutors for feedback.
      </p>
    ),
  },
  {
    id: 14,
    show: false,
    outerText: "Do you offer an Ijazah certification after completion?",
    innerText: () => (
      <p>
        Yes! We offer Ijazah (certification) in various Qira’at for qualified
        students.
      </p>
    ),
  },
  {
    id: 15,
    show: false,
    outerText: "How can I obtain an Ijazah?",
    innerText: () => (
      <ul className="list-disc ms-2">
        <li>
          Students must complete the Ijazah course under a certified teacher.
        </li>
        <li>
          They will be tested on their Tajweed, recitation, and memorization
          accuracy.
        </li>
        <li>
          Upon passing, they receive an official Ijazah certificate, allowing
          them to teach that Qira’a.
        </li>
      </ul>
    ),
  },
  {
    id: 16,
    show: false,
    outerText: "Can I get a recommendation letter after completing my course?",
    innerText: () => (
      <p>
        Yes! If you successfully complete an Ijazah program or advanced Quranic
        studies, we can provide a recommendation letter upon request. This can
        be useful if you plan to teach, pursue further Islamic studies, or apply
        for scholarships in Quranic and Islamic institutions.
      </p>
    ),
  },
  {
    id: 17,
    show: false,
    outerText: "Do you provide learning materials?",
    innerText: () => (
      <p>
        Yes, we provide digital PDF books, lesson guides, and practice
        materials.{" "}
        <Link to={academyPath}> Click To Access Learning Materials. </Link>
      </p>
    ),
  },
  {
    id: 18,
    show: false,
    outerText: "What makes Maqrahaatu Tanzeel unique?",
    innerText: () => (
      <ul className="list-disc">
        <li>
          Certified and experienced instructors, including Qari & Muqri Abu
          Malik Abdul Qudus, who is qualified in all 10 Qira’at and 20 Riwayat.
        </li>
        <li>
          A well-structured curriculum covering Hifz, Qira’at, Ijazah programs,
          and Islamic studies.
        </li>
        <li>
          Personalized learning plans based on students' abilities and progress.
        </li>
        <li>
          Flexibility in scheduling to accommodate students from different time
          zones.
        </li>
        <li>
          Recognition and certification upon successful completion of programs.
        </li>
      </ul>
    ),
  },
  {
    id: 19,
    show: false,
    outerText: "What technical setup do I need for online classes?",
    innerText: () => (
      <ul className="list-disc">
        <li>
          A laptop, tablet, or smartphone with a stable [Inter]net connection.
        </li>
        <li>A headset or microphone for clear communication.</li>
        <li>Zoom, or Google Meet installed for video classes.</li>
        nition and certification upon successful completion of programs.
      </ul>
    ),
  },
  {
    id: 20,
    show: false,
    outerText: "How much do the courses cost?",
    innerText: () => (
      <ul className="list-disc">
        <li>Course fees vary depending on the program and duration.</li>
        <li>
          Contact us for details on pricing, installment plans, and discounts.
          +234 815 378 3287
        </li>
      </ul>
    ),
  },
  {
    id: 21,
    show: false,
    outerText: "What payment methods do you accept?",
    innerText: () => (
      <ul className="list-disc">
        <li>
          Bank transfer, PayPal, and other digital payment options are
          available.
        </li>
        <li>Monthly payment plans are available for long-term courses.</li>
      </ul>
    ),
  },
];

const socialLinks = [
  {
    icon: <FaFacebook className="text-blue-500 hover:text-blue-400" />,
    url: "https://www.facebook.com/maqrahatultanzeel/",
    label: "Facebook",
  },
  {
    icon: <FaInstagram className="text-red-600 hover:text-red-400" />,
    url: "https://www.instagram.com/maqrahatultanzeel/",
    label: "Instagram",
  },
  {
    icon: <FaSquareWhatsapp className="text-green-500 hover:text-green-400" />,
    url: "https://wa.me/+2348153783287",
    label: "WhatsApp",
  },
  {
    icon: <FaTelegram className="text-blue-950 hover:text-blue-700" />,
    url: "#",
    label: "Telegram",
  },
];

export { faqs, socialLinks };
